export const completedMessages = [
  'You nailed it!',
  'Boom shakalaka!',
  'Brilliant job',
  'Outstanding!',
  'Perfect',
  'Wonderful',
  "You're really working hard today",
  'Super',
  "You're on the right track now",
  "You've got it made",
  'Good work',
  'Knew you could do it',
  'Not bad',
  "You're learning fast",
  'Nice going',
  'Wow',
  'Keep up the good work',
  'Terrific',
  'Sensational',
  'Superb',
  'That was first-class work',
  'You certainly did well today',
  "You've got your brain in gear today",
  'Excellent',
  'Tremendous',
  "You're doing beautifully",
  'Keep it up',
  'Well, look at you go',
  'Marvelous',
  'Powerful, you have become',
  'Wicked',
  "Don't stop now",
  "You're on the fast track to success",
  "You're really going for it",
  'You crushed that',
  'Check that one off your list',
  'Splendid work',
  "Now that's talent",
  'You were born to do this',
  'Another one bites the dust',
  'Another win for the books',
  'Bam! Nailed it',
  'You did it',
  'You rock',
  'Amazing',
  'Scrumtrulescent',
  'Ahh, the sweet taste of victory',
  '👌',
  '🤘',
  '💪',
  'Perfection',
  "Now that's dedication",
  "Your hard work's paying off",
  '#winning',
  '#goals',
  'Inspirational',
  "You're on fire",
  'Woot!',
  'Absolutely incredible',
  'Boom-town!',
  'Awesome!',
  'Phenomenal',
  'Most impressive!',
  'Great!',
  'Flawless victory!',
  'Groovy!',
  'Top notch!',
  'Huzzah!',
];
